import { ProfilingValidationRule, QuestionGroup } from "features/subscription-process/profiling-process/types/interfaces";

export const questionsChomageAutoAdvance: QuestionGroup[] = [
  // Groupe avec une seule question (parfait pour auto-advance)
  {
    step: 1,
    allowMultipleQuestions: false,
    questions: [
      {
        key: "ActiviteSalariale",
        label: "L'assuré est-il en activité salariale ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      }
    ]
  },
  // Groupe avec plusieurs questions
  {
    step: 2,
    allowMultipleQuestions: true,
    questions: [
      {
        key: "PeriodeEssai",
        label: "L'assuré est-il en période d'essai ou en situation de départ ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      },
      {
        key: "TempsActivite",
        label: "Est-il en activité salariale en CDI depuis plus de 6 mois chez le même employeur ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      }
    ]
  },
  {
    step: 3,
    allowMultipleQuestions: false,
    questions: [
      {
        key: "Cotisation",
        label: "Cotise-t-il chez France Travail ou équivalent ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      }
    ]
  },
  // Groupe avec questions multiples pour informations personnelles
  {
    step: 4,
    allowMultipleQuestions: true,
    questions: [
      {
        key: "CreditImmo",
        label: "L'assuré a-t-il souscrit à un crédit immobilier depuis moins de 3 ans ou est-il en train de le faire ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      },
      {
        key: "DejaAdherentAssociarea",
        label: "Le prospect est-il déjà adhérent à l'Association pour l'Union et le Recours en Assurance (ASSOCIAREA) dans le cadre d'un contrat en cours ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      }
    ]
  }
];

export const questionsChomage: QuestionGroup[] = [
  {
    step: 1,
    questions: [
      {
        key: "ActiviteSalariale",
        label: "L'assuré est-il en activité salariale ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      }
    ]
  },
  {
    step: 2,
    questions: [
      {
        key: "PeriodeEssai",
        label: "L'assuré est-il en période d'essai ou en situation de départ ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      }
    ]
  },
  {
    step: 3,
    questions: [
      {
        key: "TempsActivite",
        label: "L'assuré est-il en activité salariale CDI depuis plus de 6 mois chez le même employeur ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      }
    ]
  },
  {
    step: 4,
    questions: [
      {
        key: "Cotisation",
        label: "L'assuré cotise t-il à l’assurance chômage de France Travail ou si l’assuré est contractuel en CDI dans la fonction publique, cotise t-il à un régime équivalent ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      }
    ]
  },
  {
    step: 5,
    questions: [
      {
        key: "CreditImmo",
        label: "L'assuré a-t-il souscrit à un crédit immobilier depuis moins de 3 ans ou est-il en train de le faire ?",
        isMultipleChoice: false,
        possibleAnswers: [true, false]
      }
    ]
  },
];

export const questionValidationRules: ProfilingValidationRule[] = [
  { key: "Cotisation", expectedValue: true },
  { key: "PeriodeEssai", expectedValue: false },
  { key: "TempsActivite", expectedValue: true },
  { key: "ActiviteSalariale", expectedValue: true },
  { key: "CreditImmo", expectedValue: true },
];
